import React from "react"
import { Link} from 'gatsby'

export default props => (
    <div className="cta-buttons">
        <Link to="/sign-up" className="btn is-primary">Skrá fyrirtæki</Link>
        <Link to="/contact"  className="btn">Hafa samband</Link>
    </div>
)